import React from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import { useSelector } from 'react-redux';
import { adjustDateForTimezone } from 'helpers/intl-fns';
import { bem } from 'helpers/class-name';
import Message from 'components/Message';
import { selectActiveVenueTimezone } from 'selectors/general';
import { formatReservationName } from './attendanceInquiryUtils';
import messages from './AttendanceInquiryModal.messages';
import './AttendanceInquiryModal.scss';

const { element } = bem('attendance-inquiry-summary');

const ReservationCard = ({ inquiry }) => {
  // Venue timezone, like the question step — the same reservation must not
  // show a different time (or date) between the two views.
  const venueTimezone = useSelector(selectActiveVenueTimezone);

  const toVenueTime = date => {
    const dateObj = new Date(date);
    return venueTimezone ? adjustDateForTimezone(dateObj, venueTimezone) : dateObj;
  };

  const formatDateTime = date => (date ? format(toVenueTime(date), 'MMMM d, yyyy') : '');

  const formatTime = date => (date ? format(toVenueTime(date), 'h:mm a') : '');

  return (
    <div className={element('reservation-card')}>
      <div className={element('card-row')}>
        <span className={element('card-label')}>
          <Message message={messages.userName} />
        </span>
        <span className={element('card-value')}>{inquiry.userName}</span>
      </div>
      <div className={element('card-row')}>
        <span className={element('card-label')}>
          <Message message={messages.reservationName} />
        </span>
        <span className={element('card-value')}>{formatReservationName(inquiry.reservationName, venueTimezone)}</span>
      </div>
      <div className={element('card-row')}>
        <span className={element('card-label')}>
          <Message message={messages.date} />
        </span>
        <span className={element('card-value')}>{formatDateTime(inquiry.reservationDatetime)}</span>
      </div>
      <div className={element('card-row')}>
        <span className={element('card-label')}>
          <Message message={messages.time} />
        </span>
        <span className={element('card-value')}>{formatTime(inquiry.reservationDatetime)}</span>
      </div>
    </div>
  );
};

ReservationCard.propTypes = {
  inquiry: PropTypes.shape({
    inquiryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    userName: PropTypes.string,
    reservationName: PropTypes.string,
    reservationDatetime: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  }).isRequired,
};

export default ReservationCard;
